var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgClose = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "close_FILL0_wght300_GRAD-25_opsz20",
    d: "M274.438-685.805l-4.8,4.79a.62.62,0,0,1-.475.219.767.767,0,0,1-.48-.256.685.685,0,0,1-.228-.483.694.694,0,0,1,.236-.475l4.764-4.776-4.792-4.8a.625.625,0,0,1-.212-.469.748.748,0,0,1,.241-.489.7.7,0,0,1,.48-.247.688.688,0,0,1,.494.233l4.773,4.8,4.807-4.8a.676.676,0,0,1,.483-.228.729.729,0,0,1,.5.242.692.692,0,0,1,.222.483.694.694,0,0,1-.236.475l-4.792,4.8,4.792,4.8a.669.669,0,0,1,.226.455.673.673,0,0,1-.226.475.7.7,0,0,1-.48.247.666.666,0,0,1-.489-.238Z",
    transform: "translate(-268.45 692.795)",
    fill: "#f59064"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClose, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/close.36ee5a71.svg";
export { ForwardRef as ReactComponent };